export const LRS_ENDPOINT = (window as any)._env_?.REACT_APP_LRS_API_URL + "/add_request";
export const LRS_NOTIFY = (window as any)._env_?.REACT_APP_LRS_API_URL + "/notify_lms";
export const UPLOAD_FILE_ENDPOINT = (window as any)._env_?.REACT_APP_LRS_API_URL + "/upload_file";
export const DOWNLOAD_LICENSE_ENDPOINT = (window as any)._env_?.REACT_APP_LRS_API_URL + "/download_license";
